/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementEditMemberAddressResponse } from './MemberManagementEditMemberAddressResponse';

export type MemberManagementEditMemberAddressResponseApiRespoonse = {
    data?: MemberManagementEditMemberAddressResponse;
    status?: MemberManagementEditMemberAddressResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementEditMemberAddressResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

